import { batchHandleUrl } from '../../../utils/url-handle'

const Api = {
  valueUnique: {
    url: '/apaas/object/value/check/unique',
    type: 'post',
    parmeter: {
      'layoutApiName': String,
      'rowApiName': String,
      'buttonApiName': String,
      'fieldApiNAme': String,
      'dataVlaue': String,
      'uId': String
    }
  }
}

export default batchHandleUrl(Api)